import { combineReducers } from "redux";
import authReducer from "../slices/authSlice";
import careplanReducer from "../slices/careplanSlice";
import errorReducer from "../slices/errorSlice";
import loadingReducer from "../slices/loadingSlice";
import userReducer from "../slices/userSlice";
import auditLogsReducer from "../slices/auditLogsSlice";
import userGuideReducer from "../slices/userGuideSlice";

const appReducer = combineReducers({
  auth: authReducer,
  careplan: careplanReducer,
  error: errorReducer,
  loading: loadingReducer,
  users: userReducer,
  auditLogs: auditLogsReducer,
  userGuide: userGuideReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

export { rootReducer };
